import type { AdminCustomerListItem, CustomerLatLng } from "../customersApi";

export type LocatedCustomer = AdminCustomerListItem & {
  readonly publicContact: AdminCustomerListItem["publicContact"] & { readonly location: CustomerLatLng };
};

export function isLocated(customer: AdminCustomerListItem): customer is LocatedCustomer {
  return customer.publicContact.location !== undefined;
}
